// extracted by mini-css-extract-plugin
export var typingIndicator = "_p3-0";